module.exports = __webpack_public_path__ + "static/img/celoscope-30.65e590e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-30.jpg
// module id = vlvs
// module chunks = 52